import React from 'react';
import T from 'i18n-react';

const PrivacyPolicyComponent = ({textKey = "privacyPolicyComponent.privacyPolicyLoginPage"}) => (
    <div className="privacyPolicyContainer">
        <a
            href="/privacy-policy"
            className="link"
            target="_blank"
            rel="noopener noreferrer"
            >
            {T.translate(textKey)}
            <span className="sr-only"> (opens in a new tab)</span>
        </a>
    </div>
);

export default PrivacyPolicyComponent;
